module.exports = __webpack_public_path__ + "img/map_third-base-patio.30d0cdbe.jpg";